/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Err_Add_TitleInputs */

const es_ab_err_add_title = /** @type {(inputs: Ab_Err_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al añadir barco`)
};

const gl_ab_err_add_title = /** @type {(inputs: Ab_Err_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao engadir barco`)
};

const en_ab_err_add_title = /** @type {(inputs: Ab_Err_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error adding boat`)
};

/**
* | output |
* | --- |
* | "Error adding boat" |
*
* @param {Ab_Err_Add_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_err_add_title = /** @type {((inputs?: Ab_Err_Add_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Err_Add_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_err_add_title(inputs)
	if (locale === "en") return en_ab_err_add_title(inputs)
	return es_ab_err_add_title(inputs)
});